<div class="await-container">
    <div class="content">
        <div class="loader">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
        
        <h1 class="title">Please Wait</h1>
        <p class="message">Your environment is being setup...</p>
        
        <div class="progress-bar">
            <div class="progress-fill"></div>
        </div>
    </div>
</div>
